import { GoArrowRight } from 'react-icons/go';
import { getAuthUrl } from '@podus/utils';
import { useLanguage } from '@/i18n/LanguageContext';
import ScrollReveal from './ScrollReveal';

export default function SingleSignIn() {
    const { t } = useLanguage();
    return (
        <section className="px-4 pb-8 lg:px-16 lg:pb-12 xl:px-20">
            <ScrollReveal variant="fade-up" distance={36} duration={800}>
                <div className="bg-secondary overflow-hidden rounded-3xl">
                    <div className="flex flex-col lg:flex-row lg:items-center">
                        {/* Left Content */}
                        <div className="flex-1 px-6 py-10 lg:px-12 lg:py-16 xl:px-16">
                            <ScrollReveal variant="fade-right" delay={200} distance={30}>
                                <p className="text-secondary-50 text-sm font-medium lg:text-[15px]">
                                    {t('singleSignIn.tagline')}
                                </p>
                            </ScrollReveal>

                            <ScrollReveal variant="fade-right" delay={300} distance={30}>
                                <h2 className="mt-3 text-[28px] font-extrabold leading-[1.1] tracking-tight text-white sm:text-[36px] lg:mt-4 lg:text-[56px] xl:text-[64px]">
                                    {t('singleSignIn.heading')}
                                </h2>
                            </ScrollReveal>

                            <ScrollReveal variant="fade-up" delay={450} distance={20}>
                                <p className="text-secondary-100 mt-5 max-w-md text-sm font-medium leading-[2] sm:text-[15px] lg:mt-6">
                                    {t('singleSignIn.description')}
                                </p>
                            </ScrollReveal>

                            <ScrollReveal variant="fade-up" delay={550} distance={16}>
                                <a
                                    href={`${getAuthUrl()}/sign-up`}
                                    className="bg-primary hover:bg-primary-400 mt-8 inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-bold text-white transition-all duration-200 hover:scale-[1.03] hover:shadow-lg active:scale-[0.98] sm:px-8 sm:py-3.5 sm:text-[15px] lg:mt-10"
                                >
                                    {t('singleSignIn.cta')}
                                    <GoArrowRight className="h-4 w-4" />
                                </a>
                            </ScrollReveal>
                        </div>

                        {/* Right Illustration — Desktop only */}
                        <ScrollReveal
                            variant="fade-left"
                            delay={400}
                            duration={900}
                            distance={50}
                            className="hidden flex-1 items-center justify-center p-8 lg:flex xl:p-12"
                        >
                            <img
                                src="/tem/1597882931.png"
                                alt="Single Sign In illustration"
                                className="w-full max-w-lg object-contain xl:max-w-xl"
                            />
                        </ScrollReveal>
                    </div>
                </div>
            </ScrollReveal>
        </section>
    );
}
